import React, { createContext, useContext } from 'react';
import { usePrototype, type PrototypeApi } from '../hooks/usePrototype';
const PrototypeContext = createContext<PrototypeApi | null>(null);
export function PrototypeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const api = usePrototype();
  return <PrototypeContext.Provider value={api} data-id="element-457" data-mp="j8y0wgdbtl7j">{children}</PrototypeContext.Provider>;
}
export function useProto(): PrototypeApi {
  const value = useContext(PrototypeContext);
  if (!value) throw new Error('useProto must be used within PrototypeProvider');
  return value;
}